import { useSnackbar } from 'notistack';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';

import { NomenclatureRateCategory } from '@/types';
import { useDeleteNomenclatureRateCategoryMutation } from '@/services';

export interface DeleteNomenclatureRateCategoryProps extends DialogProps {
  nomenclatureRateCategory: NomenclatureRateCategory;
  onClose(): void;
}

const DeleteNomenclatureRateCategory: React.FC<DeleteNomenclatureRateCategoryProps> = ({
  nomenclatureRateCategory,
  onClose,
  ...props
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const [deleteNomenclatureRateCategory, deleteNomenclatureRateCategoryResponse] =
    useDeleteNomenclatureRateCategoryMutation();

  async function handleDeleteNomenclatureRateCategory() {
    try {
      await deleteNomenclatureRateCategory(nomenclatureRateCategory).unwrap();

      onClose();
    } catch (error) {
      enqueueSnackbar(error.data, { variant: 'error' });
    }
  }

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">{nomenclatureRateCategory?.name}</DialogTitle>

      <DialogContent dividers>
        <DialogContentText>Вы действительно хотите удалить "{nomenclatureRateCategory?.name}"?</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          color="secondary"
          variant="outlined"
          size="small"
          disabled={deleteNomenclatureRateCategoryResponse.isLoading}
          onClick={onClose}
        >
          Закрыть
        </Button>

        <Button
          variant="contained"
          size="small"
          disabled={deleteNomenclatureRateCategoryResponse.isLoading}
          onClick={handleDeleteNomenclatureRateCategory}
        >
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteNomenclatureRateCategory;
